import { Environment } from 'src/environmentService'
import { RootState } from 'src/store/rootReducer'

export default {
  getAngularBaseUrl: (state: RootState): string => state.environment.angularBaseUrl,
  getBaseUrl: (state: RootState): string => state.environment.baseUrl,
  getEnvironment: (state: RootState): Environment => state.environment.environment
}



// WEBPACK FOOTER //
// ./src/store/environment/selectors.ts